// The server flags projects with `mine` (from the user's Zoho "my projects" view)
// only for users on the USER_SCOPED_PROJECTS_USERS allowlist. Everyone else gets
// unflagged projects, sees the full list, and gets no "Show all" toggle.
export function hasMineFlags(projects) {
  return projects.some(p => typeof p.mine === 'boolean');
}

// The currently selected project always stays visible, so editing a timelog on a
// project outside "mine" still shows its value in the dropdown.
export function visibleProjects(projects, showAll, selectedId) {
  if (showAll || !hasMineFlags(projects)) return projects;
  return projects.filter(p => p.mine || p.id === selectedId);
}
